/* Delegated to survive native product rerenders; no cart or variant changes. */
if (!window.pkmMercuryStylingReady) {
  window.pkmMercuryStylingReady = true;
  // Safari may enable native controls when autoplay is blocked. Once playback
  // starts, restore Mercury's unobstructed video presentation, as on Slider.
  document.addEventListener('playing', (event) => {
    const video = event.target;
    if (video.matches?.('[data-pkm-mercury-autoplay] video') && video.controls) {
      video.controls = false;
    }
  }, true);
  // Native MediaCarousel pauses all players before restarting the selected one.
  // Its async `playing` attribute can still be true during that restart. Resume
  // Mercury after the native settle handler; leave other products untouched.
  document.addEventListener('carousel:settle', (event) => {
    const carousel = event.target;
    const slide = event.detail?.slide;
    const video = slide?.querySelector('[data-pkm-mercury-autoplay] video');
    if (!video || !carousel.closest('[data-pkm-mercury-gallery]')) return;
    requestAnimationFrame(() => {
      if (carousel.selectedSlide !== slide || !video.isConnected) return;
      video.play().catch(() => { /* Keep the native blocked-autoplay fallback until playback starts. */ });
    });
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mercury-zoom]');
    if (trigger) {
      const dialog = trigger.closest('[data-pkm-mercury]').querySelector('[data-mercury-dialog]');
      const img = dialog.querySelector('img');
      img.src = trigger.dataset.mercuryZoom;
      img.alt = trigger.querySelector('img').alt;
      dialog.showModal();
    }
    const closer = event.target.closest('[data-mercury-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('[data-mercury-dialog]')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
}
